export const QUERY_KEYS = {
	socialMediaOrder: "socialMediaOrder",
	companyInfo: "companyInfo",
} as const;
